import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment ChecklistTemplateItem on ChecklistTemplateModel {
    id
    version
    publishedAt
    publishedByUser {
      subjectId
      name
    }
    lists {
      type
      phases {
        name
        tasks {
          name
          allowNotRelevant
          requireCommentWhenNotRelevant
          weight
        }
      }
      checkItems {
        name
        allowNotRelevant
        requireCommentWhenNotRelevant
      }
    }
    previousVersions {
      version
      publishedAt
      publishedByUser {
        subjectId
        name
      }
    }
  }
`);

export const GET_CHECKLIST_TEMPLATE = gql(/* GraphQL */ `
  query GetChecklistTemplate {
    checklistTemplate {
      ...ChecklistTemplateItem
    }
  }
`);

export const PUBLISH_CHECKLIST_TEMPLATE_VERSION = gql(/* GraphQL */ `
  mutation ChecklistTemplatePublishVersion($input: ChecklistTemplatePublishVersionInput!) {
    checklistTemplatePublishVersion(input: $input) {
      checklistTemplateModel {
        ...ChecklistTemplateItem
      }
      errors {
        code: __typename
        ... on InvalidChecklistTemplateError {
          message
        }
        ... on UnauthorizedAccessError {
          message
        }
      }
    }
  }
`);

export const GET_CHECKLIST_EDITOR_PERMISSION = gql(/* GraphQL */ `
  query GetChecklistEditorPermission($userId: UUID!) {
    users: users(where: { subjectId: { eq: $userId } }) {
      subjectId
      canEditChecklists
    }
  }
`);

gql(/* GraphQL */ `
  fragment TaskMappingItem on ChecklistTaskMapping {
    fromPhase
    fromName
    toPhase
    toName
  }
`);

export const GET_CHECKLIST_VERSIONS_IN_USE = gql(/* GraphQL */ `
  query GetChecklistVersionsInUse {
    checklistVersionsInUse {
      version
      revisions
      tasks {
        types
        phase
        name
        completedCount
      }
      mapping {
        fromVersion
        toVersion
        pairs {
          ...TaskMappingItem
        }
      }
      suggestedPairs {
        ...TaskMappingItem
      }
    }
  }
`);

export const DEFINE_VERSION_MAPPING = gql(/* GraphQL */ `
  mutation ChecklistTemplateDefineVersionMapping($input: ChecklistTemplateDefineVersionMappingInput!) {
    checklistTemplateDefineVersionMapping(input: $input) {
      checklistTemplateModel {
        ...ChecklistTemplateItem
      }
      errors {
        code: __typename
        ... on InvalidChecklistTemplateError {
          message
        }
        ... on UnauthorizedAccessError {
          message
        }
      }
    }
  }
`);

export const MIGRATE_REVISIONS_ON_VERSION = gql(/* GraphQL */ `
  mutation ChecklistTemplateMigrateRevisions($input: ChecklistTemplateMigrateRevisionsInput!) {
    checklistTemplateMigrateRevisions(input: $input) {
      checklistBulkMigration {
        fromVersion
        toVersion
        migrated
      }
      errors {
        code: __typename
        ... on ChecklistMappingMissingError {
          message
        }
        ... on ChecklistMigrationWouldLoseWorkError {
          message
        }
        ... on UnauthorizedAccessError {
          message
        }
      }
    }
  }
`);
